var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_454_5849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41699 4.47005C3.10633 4.47005 2.85449 4.73588 2.85449 5.0638V16.1471C2.85449 16.4751 3.10633 16.7409 3.41699 16.7409H13.917C14.2277 16.7409 14.4795 16.4751 14.4795 16.1471V10.6055C14.4795 10.0589 14.8992 9.61589 15.417 9.61589C15.9348 9.61589 16.3545 10.0589 16.3545 10.6055V16.1471C16.3545 17.5681 15.2632 18.7201 13.917 18.7201H3.41699C2.0708 18.7201 0.979492 17.5681 0.979492 16.1471V5.0638C0.979492 3.64282 2.0708 2.49089 3.41699 2.49089H8.66699C9.18476 2.49089 9.60449 2.93394 9.60449 3.48047C9.60449 4.027 9.18476 4.47005 8.66699 4.47005H3.41699Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.238 11.6353L15.5989 5.97657L13.0526 3.2888L7.6917 8.94749C7.61789 9.02549 7.56547 9.12312 7.53998 9.23003L6.9458 12.4226L9.96976 11.7954C10.0713 11.7686 10.1642 11.7132 10.238 11.6353ZM17.3295 4.14981C17.5458 3.92143 17.6673 3.61172 17.6673 3.2888C17.6673 2.96587 17.5458 2.65616 17.3295 2.42778L16.4146 1.46204C16.1982 1.23373 15.9048 1.10547 15.5989 1.10547C15.2929 1.10547 14.9995 1.23373 14.7832 1.46204L13.8683 2.42778L16.4146 5.11556L17.3295 4.14981Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_454_5849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.416992,
    y: 0.314453,
    width: 18,
    height: 19,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.ce2b3faf03447af62debff72f6a8ecf0.svg";
export { ForwardRef as ReactComponent };